import {
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import CurveChart from "../charts/CurveChart";
import { PiCaretDownBold } from "react-icons/pi";
import IncDecIndicator from "../specials/IncDecIndicator";
import { useTranslation } from "../../languages";

const DashboardCRatioCard = () => {
  const { t } = useTranslation();
  return (
    <Card
      style={{ borderRadius: "20px" }}
      className="border-none standard-card full-height"
    >
      <CardBody>
        <h5 className="f-6 mb-1">{t("todaysCustomerRatio")} </h5>
        <p className="color-half-black-2">{t("current")} </p>
        <Row className="m-0">
          <Col md={6} className="p-0">
            <div>
              <h3 className="f-6">12</h3>
            </div>
          </Col>
          <Col md={6}>
            <CurveChart
              height={200}
              width={"100%"}
              xAxisData={[0, 1, 2, 3, 4, 5, 6]}
              yAxisData={[1.3, 1.5, 1.5, 1.3, 1.6, 1.4, 1.8]}
            />
          </Col>
        </Row>
        <div className="horizontal-line my-2"></div>
        <h5 className="f-6 mb-1">{t("customersReview")}</h5>
        <UncontrolledDropdown>
          <DropdownToggle className="bg-transparent p-0 mb-4 border-none color-half-black-2">
            {t("thisYear")}
            <PiCaretDownBold size={20} />
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem> {t("thisYear")}</DropdownItem>
            <DropdownItem> {t("thisMonth")}</DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
        <div className="d-flex align-items-center justify-content-between ">
          <div className="d-flex align-items-center gap-2">
            <IncDecIndicator type={"inc"} value={`6%`} />
            <small className="color-half-black-2 f-5">
              {" "}
              {t("vsYesterday")}
            </small>
          </div>
          <h4 className="f-5 my-0 mx-5">4/5</h4>
        </div>
      </CardBody>
    </Card>
  );
};

export default DashboardCRatioCard;
